/* unplugin-vue-components disabled */import { render } from "./DataDisplay.vue?vue&type=template&id=0de10954&scoped=true"
import script from "./DataDisplay.vue?vue&type=script&lang=js"
export * from "./DataDisplay.vue?vue&type=script&lang=js"

import "./DataDisplay.vue?vue&type=style&index=0&id=0de10954&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de10954"]])

export default __exports__